import { ShareAccessLevel } from './ShareAccess.types';
import { socialConfig } from './config';

export function isFeatureEnabled(
  feature: ShareAccessLevel,
  features?: Partial<Record<ShareAccessLevel, boolean>>
) {
  return features?.[feature] ?? true;
}

export function openWindow(url: string) {
  const width = 600;
  const height = 400;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;

  window.open(
    url,
    '_blank',
    `width=${width},height=${height},left=${left},top=${top},popup=yes,noopener,noreferrer`
  );
}

export function share({
  name,
  link,
  groupId,
  itemId,
}: {
  name: string;
  link: string;
  groupId: string;
  itemId: string;
}) {
  const group = Object.values(socialConfig).find((socialGroup) => groupId === socialGroup.id);

  if (!group) {
    return;
  }

  const url = group.values.find((socialItem) => socialItem.id === itemId)?.url;

  if (!url) {
    return;
  }

  const shareUrl = url
    .replace('{{url}}', encodeURIComponent(link))
    .replace('{{name}}', encodeURIComponent(name));

  openWindow(shareUrl);
}
